import type { RouteRecordRaw } from 'vue-router'

import { PAGE_TITLE } from './copy'

// Engine-scoped: the page shows the settings of the engine selected in the header.
export const routes: RouteRecordRaw[] = [
  {
    path: '/price-fetch',
    name: 'price-fetch',
    component: () => import('./PriceFetchView.vue'),
    meta: { title: PAGE_TITLE, engineScoped: true },
  },
]
